declare global {
  interface Window {
    uetq: unknown[]
  }
}

export const addMicrosoftAdvertisingEvent = () => {
  window.addEventListener('ucEvent', (event) => {
    if (
      !(
        event.detail &&
        event.detail.event === 'consent_status' &&
        event.detail.type === 'explicit'
      )
    ) {
      return
    }

    window.uetq = window.uetq || []
    window.uetq.push('consent', 'update', {
      ad_storage: event.detail['Microsoft Advertising'] ? 'granted' : 'denied',
    })
  })
}
